<template>
  <div class="tablelist">
    <div class="row align--center">
      <div class="flex xs12 md3">
        <va-input :value="term" placeholder="Doc. Auditor/Asesor" @input="search">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div class="flex xs12 md3">
        <va-select
          v-model="StatusOptionsModel"
          textBy="description"
          placeholder="Tipo Monitoreo"
          :options="this.StatusOptions"
          @change="search"
        />
      </div>
      <div class="flex xs12 md2">
        <va-input :value="term2" placeholder="Fecha de transacción" @input="search2">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div class="flex xs12 md2 offset--md2">
        <va-select v-model="perPage" :label="$t('tables.perPage')" :options="perPageOptions" />
      </div>
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="parseInt(perPage)"
      no-data-label="No se encuentran datos para esta busqueda"
    >
      <template slot="attach" slot-scope="props">
        <img class="imgdata ma-0" :id="props.rowData.IdFeedBack" src="../../assets/images/edit.png" alt="Detalle del Monitoreo" title="Detalle del Monitoreo" width="20" @click="dataReg(props, 'Detail')" />
      </template>
    </va-data-table>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'ReportMail',
  data () {
    return {
      term: null,
      term2: null,
      perPage: '20',
      perPageOptions: ['5', '10', '20', '50', '100'],
      StatusOptions: this.TypeFeed,
      StatusOptionsModel: 0,
      users: this.InfoView,
      arrayReport: [],
    }
  },
  props: {
    method: Function,
    InfoView: Array,
    HeadTable: Array,
    filterData: Array,
    TypeFeed: Array,
  },
  computed: {
    fields () {
      return this.HeadTable
    },
    filteredData () {
      debugger
      if (((!this.term2) || (this.term2.length < 1)) && ((!this.term) || (this.term.length < 1)) && (!this.StatusOptionsModel.id)) {
        return this.users
      }
      return this.users.filter(item => {
        if (this.term && this.term.length >= 1) {
          return item.DocAudit.toLowerCase().toString().startsWith(this.term.toLowerCase().toString()) || item.DocAsesor.toLowerCase().toString().startsWith(this.term.toLowerCase().toString())
        } else {
          return item
        }
      }).filter(item => {
        if (this.StatusOptionsModel.id >= 1) {
          return item.TypeAudit.toString() === this.StatusOptionsModel.description.toString()
        } else {
          return item
        }
      }).filter(item => {
        if (this.term2 && this.term2.length >= 1) {
          return item.DateTransaction.toLowerCase().toString().startsWith(this.term2.toLowerCase().toString()) || item.DateTransaction.toLowerCase().toString().startsWith(this.term2.toLowerCase().toString())
        } else {
          return item
        }
      })
    },
  },
  methods: {
    dataReg (user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
    search2: debounce(function (term2) {
      this.term2 = term2
    }, 400),
  },
}
</script>

<style>
.tablelist .va-button {
  color: #222 !important;
  border-color: #222 !important;
}

.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.tablelist .va-select__label {
  color: #222 !important;
}
.va-select__option--selected {
  color: #222 !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #222 !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #222 !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #222 !important;
}

.imgdata{
  cursor: pointer;
  margin-left: 2px !important;
  margin-right: 2px !important;
}
ul.listUL {
  width: 300px !important;
  list-style-type: square;
}
</style>
